export const setLocalStorage = (name: string, value: string): void => {
    localStorage.setItem(name, value);
};
